import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { resolveRoute } from "@analytics-setup/routeTracking";
/**
 * Fires a single `analytics.page()` on every route change across the whole app.
 *
 * Mount once at the router root (see `Routes.tsx`). This is the backbone of the
 * navigation funnel: previously only the marketing landing page and the
 * pre-login pages emitted page views, so the entire authenticated product
 * (home, overview, community, new report, etc.) was invisible in analytics.
 */
export const usePageTracking = () => {
    const analytics = useAnalytics();
    const { pathname } = useLocation();
    const lastPath = useRef(null);
    useEffect(() => {
        // Guard against duplicate fires when the effect re-runs without a real
        // navigation (e.g. the analytics instance identity changing).
        if (lastPath.current === pathname)
            return;
        lastPath.current = pathname;
        const { path, routeName, params } = resolveRoute(pathname);
        analytics.page(Object.assign({ path, routeName }, params));
    }, [analytics, pathname]);
};
